import "./widget_core.js"
import "../../../public/javascripts/backbone/lib/concerns/views/tabindex_helpers.js"
var req = require.context('../../../public/javascripts/backbone/apps/mosaic/', true, /\.js$/)
req.keys().forEach(req)
